import { createSlice } from "@reduxjs/toolkit";
import { setAddressDetailData } from "./addressSlice";
import { resetBankDetailsData, setBankDetailsData } from "./bankSlice";
import { resetBoidData, setBoidData, setBoidOtherData } from "./boidSlice";
import {
  resetDirectorDetailListData,
  setDirectorDetailData,
  setDirectorDetailListData,
  setDirectorDocumentListData,
} from "./directorSlice";
import {
  clearDocumentData,
  resetDocumentListData,
  setDocumentListData,
} from "./documentSlice";
import { resetDynamicData } from "./dynamicFieldSlice";
import {
  disableSection,
  setMainRouterData,
  setSectionComplete,
} from "./routerSlice";
import {
  setBiometricsDetailsData
} from "./biometricsSlice";

export const companyDetailsSlice = createSlice({
  name: "companyDetails",
  initialState: { countryOfRegistration: "NP", hasPan: true, errors: {}, incorporationDate: null },
  reducers: {
    setCompanyName: (state, action) => {
      state.companyName = action.payload;
      state.errors.companyNameError = {};
      state.op = "U";
    },
    setCeoFirstName: (state, action) => {
      state.ceoFirstName = action.payload;
      state.errors.ceoFirstNameError = {};
      state.op = "U";
    },
    setCeoMiddleName: (state, action) => {
      state.ceoMiddleName = action.payload;
      state.errors.middleNameError = {};
      state.op = "U";
    },
    setCeoLastName: (state, action) => {
      state.ceoLastName = action.payload;
      state.errors.ceoLastNameError = {};
      state.op = "U";
    },
    setSecFirstName: (state, action) => {
      state.secFirstName = action.payload;
      state.errors.secFirstNameError = {};
      state.op = "U";
    },
    setSecMiddleName: (state, action) => {
      state.secMiddleName = action.payload;
      state.errors.secMiddleNameError = {};
      state.op = "U";
    },
    setSecLastName: (state, action) => {
      state.secLastName = action.payload;
      state.errors.secLastNameError = {};
      state.op = "U";
    },
    setIncorporationDate: (state, action) => {
      state.incorporationDate = action.payload;
      state.errors.incorporationDateError = {};
      state.op = "U";
    },
    setIncorporationDateBs: (state, action) => {
      state.incorporationDateBs = action.payload;
      state.errors.incorporationDateBsError = {};
      state.op = "U";
    },

    setCompanyType: (state, action) => {
      state.companyType = action.payload;
      state.errors.companyTypeError = {};
      state.op = "U";
    },
    setCountryOfRegistration: (state, action) => {
      state.countryOfRegistration = action.payload;
      state.errors.countryOfRegistrationError = {};
      state.op = "U";
    },
    setRegistrationOffice: (state, action) => {
      state.registrationOffice = action.payload;
      state.errors.registrationOfficeError = {};
      state.op = "U";
    },
    setRegistrationNo: (state, action) => {
      state.registrationNo = action.payload;
      state.errors.registrationNoError = {};
      state.op = "U";
    },
    setRegistrationDate: (state, action) => {
      state.registrationDate = action.payload;
      state.errors.registrationDateError = {};
      state.op = "U";
    },
    setPanVatRegistraionNo: (state, action) => {
      state.panVatRegistrationNo = action.payload;
      state.errors.panVatRegistrationNoError = {};
      state.op = "U";
    },
    setHasPan: (state, action) => {
      state.hasPan = action.payload;
      state.errors.hasPanError = {};
      state.op = "U";
    },
    setPanEximption: (state, action) => {
      state.panEximption = action.payload;
      state.errors.panEximptionError = {};
      state.op = "U";
    },
    setRegDistrict: (state, action) => {
      state.regDistrict = action.payload;
      state.errors.regDistrictError = {};
      state.op = "U";
    },

    setIsSubsidiary: (state, action) => {
      state.isSubsidiary = action.payload;
      state.errors.isSubsidiaryError = {};
      state.op = "U";
      if (!state.isSubsidiary) {
        state.nameAddressOfCompany = "";
      }
    },
    setNameAddressOfCompany: (state, action) => {
      state.nameAddressOfCompany = action.payload;
      state.errors.nameAddressOfCompanyError = {};
      state.op = "U";
    },
    setTypesOfBusinessOfCompany: (state, action) => {
      state.typesOfBusinessOfCompany = action.payload;
      state.errors.typesOfBusinessOfCompanyError = {};
      state.op = "U";
    },
    setAreaOfWork: (state, action) => {
      state.areaOfWork = action.payload;
      state.errors.areaOfWorkError = {};
      state.op = "U";
    },
    setIsListed: (state, action) => {
      state.isListed = action.payload;
      state.errors.isListedError = {};
      state.op = "U";
      if (!state.isListed) {
        state.listingDate = "";
        state.listingDateBs = "";
      }
    },
    setListingDate: (state, action) => {
      state.listingDate = action.payload;
      state.errors.listingDateError = {};
      state.op = "U";
    },
    setCompanyTypeOthers: (state, action) => {
      state.companyTypeOthers = action.payload;
      state.errors.companyTypeOthersError = {};
      state.op = "U";
    },
    setBusinessTypeOthers: (state, action) => {
      state.businessTypeOthers = action.payload;
      state.errors.businessTypeOthersError = {};
      state.op = "U";
    },
    setRegistrationDateBs: (state, action) => {
      state.registrationDateBs = action.payload;
      state.errors.registrationDateBsError = {};
      state.op = "U";
    },
    setListingDateBs: (state, action) => {
      state.listingDateBs = action.payload;
      state.errors.listingDateBsError = {};
      state.op = "U";
    },
    setCompanyTypeDesc: (state, action) => {
      state.companyTypeDesc = action.payload;
      state.op = "U";
    },
    setTypesOfBusinessOfCompanyDesc: (state, action) => {
      state.typesOfBusinessOfCompanyDesc = action.payload;
      state.op = "U";
    },
    setCountryOfRegistrationDesc: (state, action) => {
      state.countryOfRegistrationDesc = action.payload;
      state.op = "U";
    },

    setCompanyDetailData: (state, action) => {
      Object.keys(action.payload).forEach(
        (key) => (state[key] = action.payload[key])
      );
      state.op = "N";
    },
    setCompanyNameError: (state, action) => {
      state.errors.companyNameError = {};
      state.errors.companyNameError.message = action.payload.message;
      state.errors.companyNameError.section = action.payload.section;
    },
    setCompanyTypeError: (state, action) => {
      state.errors.companyTypeError = {};
      state.errors.companyTypeError.message = action.payload.message;
      state.errors.companyTypeError.section = action.payload.section;
    },
    setPanVatRegistrationNoError: (state, action) => {
      state.errors.panVatRegistrationNoError = {};
      state.errors.panVatRegistrationNoError.message = action.payload.message;
      state.errors.panVatRegistrationNoError.section = action.payload.section;
    },
    setIncorporationDateError: (state, action) => {
      state.errors.incorporationDateError = {};
      state.errors.incorporationDateError.message = action.payload.message;
      state.errors.incorporationDateError.section = action.payload.section;
    },
    setCountryOfRegistrationError: (state, action) => {
      state.errors.countryOfRegistrationError = {};
      state.errors.countryOfRegistrationError.message = action.payload.message;
      state.errors.countryOfRegistrationError.section = action.payload.section;
    },
    setRegistrationNoError: (state, action) => {
      state.errors.registrationNoError = {};
      state.errors.registrationNoError.message = action.payload.message;
      state.errors.registrationNoError.section = action.payload.section;
    },
    setRegistrationOfficeError: (state, action) => {
      state.errors.registrationOfficeError = {};
      state.errors.registrationOfficeError.message = action.payload.message;
      state.errors.registrationOfficeError.section = action.payload.section;
    },
    setRegistrationDateError: (state, action) => {
      state.errors.registrationDateError = {};
      state.errors.registrationDateError.message = action.payload.message;
      state.errors.registrationDateError.section = action.payload.section;
    },
    setTypesOfBusinessOfCompanyError: (state, action) => {
      state.errors.typesOfBusinessOfCompanyError = {};
      state.errors.typesOfBusinessOfCompanyError.message =
        action.payload.message;
      state.errors.typesOfBusinessOfCompanyError.section =
        action.payload.section;
    },
    setAreaOfWorkError: (state, action) => {
      state.errors.areaOfWorkError = {};
      state.errors.areaOfWorkError.message = action.payload.message;
      state.errors.areaOfWorkError.section = action.payload.section;
    },
    setNameAddressOfCompanyError: (state, action) => {
      state.errors.nameAddressOfCompanyError = {};
      state.errors.nameAddressOfCompanyError.message = action.payload.message;
      state.errors.nameAddressOfCompanyError.section = action.payload.section;
    },
    setIsListedError: (state, action) => {
      state.errors.isListedError = {};
      state.errors.isListedError.message = action.payload.message;
      state.errors.isListedError.section = action.payload.section;
    },
    setListingDateError: (state, action) => {
      state.errors.listingDateError = {};
      state.errors.listingDateError.message = action.payload.message;
      state.errors.listingDateError.section = action.payload.section;
    },
    setHasPanError: (state, action) => {
      state.errors.hasPanError = {};
      state.errors.hasPanError.message = action.payload.message;
      state.errors.hasPanError.section = action.payload.section;
    },
    setIsSubsidiaryError: (state, action) => {
      state.errors.isSubsidiaryError = {};
      state.errors.isSubsidiaryError.message = action.payload.message;
      state.errors.isSubsidiaryError.section = action.payload.section;
    },
    setPanEximptionError: (state, action) => {
      state.errors.panEximptionError = {};
      state.errors.panEximptionError.message = action.payload.message;
      state.errors.panEximptionError.section = action.payload.section;
    },
    setRegDistrictError: (state, action) => {
      state.errors.regDistrictError = {};
      state.errors.regDistrictError.message = action.payload.message;
      state.errors.regDistrictError.section = action.payload.section;
    },
    clearCompanyErrorMsg: (state) => {
      state.errors = {};
    },
  },
});

export const {
  setCompanyDetailData,
  setCompanyName,
  setCeoFirstName,
  setCeoMiddleName,
  setCeoLastName,
  setSecFirstName,
  setSecLastName,
  setSecMiddleName,
  setIncorporationDate,
  setCompanyType,
  setCountryOfRegistration,
  setRegistrationOffice,
  setRegistrationNo,
  setRegistrationDate,
  setPanVatRegistraionNo,
  setIsSubsidiary,
  setNameAddressOfCompany,
  setTypesOfBusinessOfCompany,
  setAreaOfWork,
  setIsListed,
  setListingDate,
  setCompanyTypeOthers,
  setBusinessTypeOthers,
  setCompanyTypeDesc,
  setTypesOfBusinessOfCompanyDesc,
  setCountryOfRegistrationDesc,
  setIncorporationDateBs,
  setRegistrationDateBs,
  setListingDateBs,
  setCompanyNameError,
  setCompanyTypeError,
  setRegistrationDateError,
  setPanNoError,
  setIncorporationDateError,
  setCountryOfRegistrationError,
  setRegistrationNoError,
  setRegistrationOfficeError,
  setTypesOfBusinessOfCompanyError,
  setAreaOfWorkError,
  setNameAddressOfCompanyError,
  setIsListedError,
  setListingDateError,
  setIsSubsidiaryError,
  setPanVatRegistrationNoError,
  clearCompanyErrorMsg,
  setHasPan,
  setHasPanError,
  setPanEximption,
  setPanEximptionError,
  setRegDistrict,
  setRegDistrictError
} = companyDetailsSlice.actions;

export default companyDetailsSlice.reducer;

export const updateCompanyRouterData = (data) => (dispatch) => {
  const companyDetail = data.companyDetail;

  if (companyDetail) {
    if (companyDetail.op === "I") {
      const companyDetails = {
        id: companyDetail.id,
        op: "N",
        customerId: data.id,
        tempKycId: data.tempKycId,
        permKycId: data.permKycId,
        isForBoid: data.isForBoid,
        dpId: data.dpId,
        status: data.status,
      };

      dispatch(setCompanyDetailData(companyDetails));
    }

    const pdd =
      companyDetail.addressDetailList[0] &&
      (companyDetail.addressDetailList[0].addressTypeId == 1
        ? companyDetail.addressDetailList[0]
        : companyDetail.addressDetailList[1]);
    const tdd =
      companyDetail.addressDetailList[0] &&
      (companyDetail.addressDetailList[0].addressTypeId == 1
        ? companyDetail.addressDetailList[1]
        : companyDetail.addressDetailList[0]);

    if (pdd || tdd) {
      const addressDetails = {
        ...(pdd
          ? {
            pid: pdd.id,
            pop: "N",
          }
          : {}),
        ...(tdd
          ? {
            id: tdd.id,
            op: "N",
          }
          : {}),
      };

      dispatch(setAddressDetailData(addressDetails));
    }

    if (companyDetail.directorDetailList) {
      const directorDetailsList = companyDetail.directorDetailList
        .filter((d) => d.op !== "D")
        .map((director) => {
          let directorDetails = {};

          directorDetails.id = director.id;
          directorDetails.authorizedPerson = director.isAuthorized;
          directorDetails.type = director.directorTypeId;
          directorDetails.directorTypeOthers = director.directorTypeOthers;
          directorDetails.designation = director.designation;
          directorDetails.op = director.op;
          directorDetails.isContactPerson = director.isContactPerson;
          directorDetails.isPrimaryContactPerson = director.isPrimaryContactPerson;
          directorDetails.isDirector = director.isDirector;
          directorDetails.designationOthers = director.designationOthers;

          if (director.personDetail) {
            directorDetails.pid = director.personDetail.id;
            directorDetails.firstName = director.personDetail.fname;
            directorDetails.middleName = director.personDetail.mname;
            directorDetails.lastName = director.personDetail.lname;
            directorDetails.panNo = director.personDetail.pan;
            directorDetails.pop = director.personDetail.op;

            director.personDetail.addressDetailList.forEach((address) => {
              if (address.addressTypeId == 1) {
                directorDetails = {
                  ...directorDetails,
                  ...{
                    ppaid: address.id,
                    ppaop: address.op,
                    perCountry: address.countryCd,
                    perState: address.stateCd,
                    perDistrict: address.districtCd,
                    perMunicipality: address.municipalityCd,
                    perWard: address.ward,
                    perTole: address.tole,
                    perBlockNo: address.blockNo,
                    perTelephoneNo: address.phoneNo,
                  },
                };
              } else {
                directorDetails = {
                  ...directorDetails,
                  ...{
                    paid: address.id,
                    paop: address.op,
                    country: address.countryCd,
                    state: address.stateCd,
                    district: address.districtCd,
                    municipality: address.municipalityCd,
                    ward: address.ward,
                    tole: address.tole,
                    blockNo: address.blockNo,
                    telephoneNo: address.phoneNo,
                    emailId: address.email,
                    mobileNo: address.mobileNo,
                  },
                };
              }
            });

            director.personDetail.familyDetailList.forEach((family) => {
              if (family.relationTypeId === "GF") {
                directorDetails = {
                  ...directorDetails,
                  ...{
                    pgfid: family.id,
                    pgfpid: family.personDetail.id,
                    pgfpop: family.personDetail.op,
                    relationTypeId: family.relationTypeId,
                    grandFatherFirstName: family.personDetail.fname,
                    grandFatherMiddleName: family.personDetail.mname,
                    grandFatherLastName: family.personDetail.lname,
                  },
                };
              } else if (family.relationTypeId === "F") {
                directorDetails = {
                  ...directorDetails,
                  ...{
                    pfid: family.id,
                    pfpop: family.personDetail.op,
                    pfpid: family.personDetail.id,
                    relationTypeId: family.relationTypeId,
                    fatherFirstName: family.personDetail.fname,
                    fatherMiddleName: family.personDetail.mname,
                    fatherLastName: family.personDetail.lname,
                  },
                };
              } else if (family.relationTypeId === "SP") {
                directorDetails = {
                  ...directorDetails,
                  ...{
                    pspid: family.id,
                    psppop: family.personDetail.op,
                    psppid: family.personDetail.id,
                    relationTypeId: family.relationTypeId,
                    spouseFirstName: family.personDetail.fname,
                    spouseMiddleName: family.personDetail.mname,
                    spouseLastName: family.personDetail.lname,
                  },
                };
              }
            });

            directorDetails.documentList =
              director.personDetail.personDocumentDetailList;
          }

          return directorDetails;
        });

      dispatch(resetDirectorDetailListData(directorDetailsList));
    }

    const companyDocumentDetailList = companyDetail.documentDetailList
      .filter((d) => d.op !== "D")
      .map((d) => ({ ...d, issuedDate: d.issuedDate }));

    dispatch(resetDocumentListData(companyDocumentDetailList));
  }
};

export const updateOtherRouterData = (data) => (dispatch) => {
  const bankAccountDeatilList = data.bankAccountDetailList
    .map((bankAccount) => ({
      id: bankAccount.id,
      bankAccountNumber: bankAccount.accountNo,
      typesOfBankAccount: bankAccount.accountType,
      isPrimaryAccount: bankAccount.isPrimaryAccount,
      bank: bankAccount.bankId,
      op: bankAccount.op,
    }))
    .filter((d) => d.op !== "D");

  dispatch(resetBankDetailsData(bankAccountDeatilList));

  const boidList = data.boIdList
    .map((boid) => ({
      id: boid.id,
      boid: boid.boId,
      dpId: boid.dpId,
      isForwarded: boid.isForwarded,
      op: boid.op,
      dpIdDesc: boid.dpIdDesc,
    }))
    .filter((d) => d.op !== "D");

  dispatch(resetBoidData(boidList));

  dispatch(
    setMainRouterData({
      customerId: data.id,
      formType: data.type || "C",
      tempKycId: data.tempKycId,
      permKycId: data.permKycId,
      isForBoid: data.isForBoid,
      dpId: data.dpId,
      status: data.status,
    })
  );

  dispatch(resetDynamicData(boidList));
};

export const setCompanyRouterData = (data) => (dispatch) => {
  console.log("data: ", data);
  const companyDetail = data.companyDetail;

  const companyDetails = {
    id: companyDetail.id,
    op: "N",
    customerId: data.id,
    tempKycId: data.tempKycId,
    permKycId: data.permKycId,
    isForBoid: data.isForBoid,
    dpId: data.dpId,
    status: data.status,

    companyName: companyDetail.name,
    ceoFirstName: companyDetail.ceoFirstName,
    ceoMiddleName: companyDetail.ceoMiddleName,
    ceoLastName: companyDetail.ceoLastName,
    secFirstName: companyDetail.secretaryFirstName,
    secMiddleName: companyDetail.secretaryMiddleName,
    secLastName: companyDetail.secretaryLastName,
    companyType: companyDetail.companyTypeCd,
    companyTypeDesc: companyDetail.companyTypeDesc,
    registrationDate: companyDetail.registrationDate,
    incorporationDate: companyDetail.dateOfIncop,
    countryOfRegistration: companyDetail.countryCd,
    countryOfRegistrationDesc: companyDetail.countryDesc,
    registrationOffice: companyDetail.regOffice,
    registrationNo: companyDetail.regNo,
    panVatRegistrationNo: companyDetail.pan,
    hasPan: companyDetail.hasPan,
    typesOfBusinessOfCompany: companyDetail.bussinessTypeId,
    typesOfBusinessOfCompanyDesc: companyDetail.businessTypeDesc,
    areaOfWork: companyDetail.areaOfWork,
    nameAddressOfCompany: companyDetail.headOfficeName,
    isListed: companyDetail.isListed,
    listingDate: companyDetail.listingDate,
    companyTypeOthers: companyDetail.companyTypeOthers,
    businessTypeOthers: companyDetail.businessTypeOthers,
    listingDateBs: companyDetail.listingDateBs,
    isSubsidiary: companyDetail.isSubsidiary,
    incorporationDateBs: companyDetail.dateOfIncopBs,
    registrationDateBs: companyDetail.registrationDateBs,
    regDistrict: companyDetail.regDistrict,
    panEximption: companyDetail.panEximption,

    isSignature: companyDetail.isSignature,
    isBiometric: companyDetail.isBiometric,
  };

  dispatch(setCompanyDetailData(companyDetails));

  const pdd =
    (companyDetail.addressDetailList[0] &&
      (companyDetail.addressDetailList[0].addressTypeId === 1
        ? companyDetail.addressDetailList[0]
        : companyDetail.addressDetailList[1])) ||
    {};
  const tdd =
    (companyDetail.addressDetailList[0] &&
      (companyDetail.addressDetailList[0].addressTypeId === 1
        ? companyDetail.addressDetailList[1]
        : companyDetail.addressDetailList[0])) ||
    {};

  console.log("data22");
  const addressDetails = {
    id: tdd.id,
    pid: pdd.id,
    perCountry: pdd.countryCd || tdd.countryCd,
    perState: pdd.stateCd,
    perDistrict: pdd.districtCd,
    perMunicipality: pdd.municipalityCd,
    perWard: pdd.ward,
    perTole: pdd.tole,
    perBlockNo: pdd.blockNo,
    perTelephoneNo: pdd.phoneNo,
    country: tdd.countryCd,
    state: tdd.stateCd,
    district: tdd.districtCd,
    municipality: tdd.municipalityCd,
    ward: tdd.ward,
    website: tdd.website,
    tole: tdd.tole,
    blockNo: tdd.blockNo,
    telephoneNo: tdd.phoneNo,
    emailId: tdd.email,
    mobileNo: tdd.mobileNo,
    hasPermanentAddressSame: pdd.hasPermanentAddressSame,
    LatLng: {
      mapPosition: { lat: tdd.lat, lng: tdd.lng },
      markerPosition: { lat: tdd.lat, lng: tdd.lng },
    },
    pop: "N",
    op: "N",
    countryDesc: tdd.countryDesc,
    stateDesc: tdd.stateDesc,
    districtDesc: tdd.districtDesc,
    municipalityDesc: tdd.municipalityDesc,
  };

  const directorDetailsList = companyDetail.directorDetailList.map(
    (director) => {
      let directorDetails = {};

      directorDetails.id = director.id;
      directorDetails.authorizedPerson = director.isAuthorized;
      directorDetails.type = director.directorTypeId;
      directorDetails.directorTypeOthers = director.directorTypeOthers;
      directorDetails.designation = director.designation;
      directorDetails.op = "N";
      directorDetails.directorTypeDesc = director.directorTypeDesc;
      directorDetails.isContactPerson = director.isContactPerson;
      directorDetails.isPrimaryContactPerson = director.isPrimaryContactPerson;
      directorDetails.isDirector = director.isDirector;
      directorDetails.designationOthers = director.designationOthers;

      if (director.personDetail) {
        directorDetails.pid = director.personDetail.id;
        directorDetails.firstName = director.personDetail.fname;
        directorDetails.middleName = director.personDetail.mname;
        directorDetails.lastName = director.personDetail.lname;
        directorDetails.panNo = director.personDetail.pan;
        directorDetails.pop = "N";

        director.personDetail.addressDetailList.forEach((address) => {
          if (address.addressTypeId == 1) {
            directorDetails = {
              ...directorDetails,
              ...{
                ppaid: address.id,
                ppaop: "N",
                perCountry: address.countryCd,
                perState: address.stateCd,
                perDistrict: address.districtCd,
                perMunicipality: address.municipalityCd,
                perWard: address.ward,
                perTole: address.tole,
                perBlockNo: address.blockNo,
                perTelephoneNo: address.phoneNo,
                perCountryDesc: address.countryDesc,
                perStateDesc: address.stateDesc,
                perDistrictDesc: address.districtDesc,
                perMunicipalityDesc: address.municipalityDesc,
                hasPermanentAddressSame: address.hasPermanentAddressSame
              },
            };
          } else {
            directorDetails = {
              ...directorDetails,
              ...{
                paid: address.id,
                paop: "N",
                country: address.countryCd,
                state: address.stateCd,
                district: address.districtCd,
                municipality: address.municipalityCd,
                ward: address.ward,
                tole: address.tole,
                blockNo: address.blockNo,
                telephoneNo: address.phoneNo,
                emailId: address.email,
                mobileNo: address.mobileNo,
                countryDesc: address.countryDesc,
                stateDesc: address.stateDesc,
                districtDesc: address.districtDesc,
                municipalityDesc: address.municipalityDesc
              },
            };
          }
        });

        director.personDetail.familyDetailList.forEach((family) => {
          if (family.relationTypeId === "GF") {
            directorDetails = {
              ...directorDetails,
              ...{
                pgfid: family.id,
                pgfpid: family.personDetail.id,
                pgfpop: "N",
                relationTypeId: family.relationTypeId,
                grandFatherFirstName: family.personDetail.fname,
                grandFatherMiddleName: family.personDetail.mname,
                grandFatherLastName: family.personDetail.lname,
              },
            };
          } else if (family.relationTypeId === "F") {
            directorDetails = {
              ...directorDetails,
              ...{
                pfid: family.id,
                pfpop: "N",
                pfpid: family.personDetail.id,
                relationTypeId: family.relationTypeId,
                fatherFirstName: family.personDetail.fname,
                fatherMiddleName: family.personDetail.mname,
                fatherLastName: family.personDetail.lname,
              },
            };
          } else if (family.relationTypeId === "SP") {
            directorDetails = {
              ...directorDetails,
              ...{
                pspid: family.id,
                psppop: "N",
                psppid: family.personDetail.id,
                relationTypeId: family.relationTypeId,
                spouseFirstName: family.personDetail.fname,
                spouseMiddleName: family.personDetail.mname,
                spouseLastName: family.personDetail.lname,
              },
            };
          }
        });

        directorDetails.documentList =
          director.personDetail.personDocumentDetailList;
        directorDetails.documentList.forEach((d) => (d.op = "N"));
      }

      return directorDetails;
    }
  );

  dispatch(
    setBiometricsDetailsData(companyDetail.biometricsDetailsList)
  );
  dispatch(setDirectorDetailListData(directorDetailsList));

  const companyDocumentDetailList = companyDetail.documentDetailList.map(
    (d) => ({ ...d, op: "N", issuedDate: d.issuedDate })
  );

  const locationType =
    companyDocumentDetailList &&
      companyDocumentDetailList.find(
        (d) => d.documentTypeId === "MP" && d.fileId
      ) ?
      "I" : 'G';

  addressDetails.locationType = locationType;

  dispatch(setAddressDetailData(addressDetails));

  dispatch(setDocumentListData(companyDocumentDetailList));

  const bankAccountDeatilList = data.bankAccountDetailList.map(
    (bankAccount) => ({
      id: bankAccount.id,
      bankAccountNumber: bankAccount.accountNo,
      typesOfBankAccount: bankAccount.accountType,
      isPrimaryAccount: bankAccount.isPrimaryAccount,
      bank: bankAccount.bankId,
      op: "N",
      bankBranch: bankAccount.bankBranchCd,
      bankDesc: bankAccount.bankDesc,
      bankBranchDesc: bankAccount.bankBranchDesc,
      typesOfBankAccountDesc: bankAccount.bankAccountTypeDesc,
    })
  );

  dispatch(setBankDetailsData(bankAccountDeatilList));

  const boidList = data.boIdList.map((boid) => ({
    id: boid.id,
    boid: boid.boId,
    dpId: boid.dpId,
    isForwarded: boid.isForwarded,
    op: "N",
    dpIdDesc: boid.dpIdDesc,
  }));

  dispatch(setBoidData(boidList));

  if (!boidList.length && data.dpId)
    dispatch(
      setBoidOtherData({
        createBoid: data.isForBoid,
        fdpId: data.dpId,
      })
    );
  else
    dispatch(
      setBoidOtherData({
        createBoid: data.isForBoid,
      })
    );

  dispatch(
    setMainRouterData({
      customerId: data.id,
      formType: data.type || "C",
      tempKycId: data.tempKycId,
      permKycId: data.permKycId,
      isForBoid: data.isForBoid,
      dpId: data.dpId,
      status: data.status,
    })
  );
};
